import { useCallback, useEffect, useState } from 'react';
import { FetchSoldProductsSearchProps, ListSalesByDate, SalesByDate } from 'lib/models/listSoldProducts';

function useSalesByDate(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [data, setData] = useState<SalesByDate[]>([]);

	const refetch = useCallback(
		async (props?: FetchSoldProductsSearchProps) => {
			setLoading(true);
			const response = await ListSalesByDate(props || searchProps);
			setData(response);
			setLoading(false);
		},
		[searchProps]
	);

	useEffect(() => {
		refetch(searchProps);
	}, [refetch, searchProps]);

	return { loading, data, refetch };
}

export default useSalesByDate;
